import { Action, createReducer, on } from "@ngrx/store";
import * as fromPage from "../actions/page.action";

export interface PageState {
    pageFullscreen: boolean;
}

export const initialState: PageState = {
    pageFullscreen: false
};

const pageReducer = createReducer(
    initialState,
    on(fromPage.setPageFullscreen, (state, { pageFullscreen }) => {
        return {
            ...state,
            pageFullscreen: pageFullscreen
        };
    })
);

// exporting the reducer so it can be added to the index file
export function reducer(state: PageState | undefined, action: Action) {
    return pageReducer(state, action);
}

export const getPageFullscreen = (state: PageState) => state.pageFullscreen;
